import { Injectable } from '@angular/core';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { TimePicker } from 'src/app/models/material/time-picker.type';

@Injectable({
  providedIn: 'root'
})
export class TimePickerService {

  constructor() { }

  get time00InTimePickerFormat(): NgbTimeStruct {
    return { hour: 0, minute: 0, second: 0 }
  }

  formatTimePickerToString(timePickerValue: TimePicker): string {
    let hour: string = this.verifyTimePickerLength(timePickerValue.hour)
    let minute: string = this.verifyTimePickerLength(timePickerValue.minute)
    return `${hour}:${minute}:00`
  }

  verifyTimePickerLength(time: number): string {
    return String(time).length === 1 ? `0${time}` : String(time)
  }

  formatStringToTimePicker(timeInString: string): TimePicker {
    return { hour: Number(timeInString.split(':')[0]), minute: Number(timeInString.split(':')[1]) }
  }

  /**
   * Service function
   * validates the hours set by the user.
   * @returns true if the hour is invalid and false if it is valid.
   */
  isTimeInvalid(timePicker: { beginTime: TimePicker, endTime: TimePicker }): boolean {
    let beginTime: TimePicker = timePicker.beginTime
    let endTime: TimePicker = timePicker.endTime
    return beginTime.hour > endTime.hour
      || beginTime.hour === endTime.hour && beginTime.minute > endTime.minute
  }
}
